<template>
  <!-- <div id="carouselExample2" class="carousel slide" data-ride="carousel">
      <div class="carousel-inner" style="height: 600px">
          <div class="carousel-item active">
              <img    src="https://cdn.gosmart.mn/1CwVzESJi02bf48yzUFpWw/cf7a53d4-1a2e-4890-90c6-87915b3a6a4f/DynamicOffice/rectangle%203.png" class="d-block w-100" style="height: 60vh" />
          </div>
      </div>
    </div> -->
  <b-carousel
    class="loc-type-carousel"
    v-model="slide"
    :interval="4000"
    controls
    indicators
  >
    <!-- Slides with image only -->
    <!-- <b-carousel-slide v-for="(t,i) in tasks" :key="i" :img-src="`${t.defaultAttachmentUrl}?w=1920&h=600&mode=crop`"></b-carousel-slide> -->
    <!-- <div class="loc-type-carousel-image" v-for="(t,i) in tasks" :key="i" :style="`background: url('${t.defaultAttachmentUrl}?w=1920&h=600&mode=crop')`"></div> -->
    <b-carousel-slide v-for="(t, i) in tasks" :key="i">
      <template #img>
        <!-- <div style="height: 600px !important"
            class="d-block img-fluid w-100"
            :style="`background-image: url('${t.defaultAttachmentUrl}?w=1920&h=600&mode=crop')`"
            alt="image slot"
          ></div> -->
        <div
          class="loc-type-carousel-image"
          :style="
            `background: url('${t.defaultAttachmentUrl}?w=1920&h=600&mode=crop')`
          "
        ></div>
      </template>
    </b-carousel-slide>
  </b-carousel>
</template>

<script>
import { request } from "@/api/all";

export default {
  props: {
    comp: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tasks: [],
      slide: 0,
      sliding: null
    };
  },
  mounted() {
    this.loadTasks(this.comp.locTypeId1);
  },
  methods: {
    loadTasks(typeId) {
      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          skip: 0,
          size: 3,
          ot: 357,
          model: {
            isPublic: true,
            locTypeId1: typeId
          }
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.tasks = res.data.tasks;
        }
      });
    }
  }
};
</script>

<style lang="scss">
.loc-type-carousel {
  .carousel-item {
    height: 600px !important;
  }
  .loc-type-carousel-image {
    height: 600px !important;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    background-position: center top !important;
  }
  .carousel-control-prev {
    .carousel-control-prev-icon {
      display: inline-block !important;
      width: 20px !important;
      height: 20px !important;
      background: 50%/100% 100% no-repeat !important;
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e") !important;
    }
  }
  .carousel-control-next {
    .carousel-control-next-icon {
      display: inline-block !important;
      width: 20px !important;
      height: 20px !important;
      background: 50%/100% 100% no-repeat !important;
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e") !important;
    }
  }
}
</style>
